<template>
  <layout>
    <!--城市选择区-->
    <template v-slot:pageLeft>
      <QHleftcity @change="change" @cityLoading="cityLoading" ref="QHleftcity"></QHleftcity>
    </template>
    <!--城市选择区 end-->

    <!--总统计区-->
    <template v-slot:pageTab>
      <div class="headerA flex-center">
        <div class="flex-center-col">
          <font class="fontColor">备案中心</font>
        </div>
      </div>
      <div class="headerB flex-between">
        <div class="flex-center-y">
          <dl class="item">
            <dt class="bigNumber flex-center-y">
              <div class="danwei">
                <span>{{ dataName }}</span> <br />备案数
              </div>
              <div class="num flex-center">
                <span v-for="(item, index) in $numToArr( total.thisCountDan || 0 )" :key="index">
                    <font>{{item}}</font>
                </span>
              </div>
              <div class="danwei">单</div>
            </dt>
          </dl>
          <dl class="item">
            <dt class="bigNumber flex-center-y">
              <div class="danwei">备<br />案</div>
              <div class="num flex-center">
                <span v-for="(item, index) in $numToArr( total.thisCountDun || 0 )" :key="index">
                    <font>{{item}}</font>
                </span>
              </div>
              <div class="danwei">吨</div>
              <div class="num flex-center">
                <span v-for="(item, index) in $numToArr( total.thisCountLifang || 0 )" :key="index">
                    <font>{{item}}</font>
                </span>
              </div>
              <div class="danwei">m³</div>
            </dt>
          </dl>
        </div>
      </div>
    </template>
    <!--总统计区 end-->

    <!--搜索及功能区-->
    <template v-slot:pageSearch>
      <ul class="tab">
        <li>
          <Input size="small" v-model="searchMap.keyword" placeholder="排放单位" style="width: 150px" />
        </li>
        <li style="width: 200px">
          <QHdatePicker v-model="searchMap.daterange" type="daterange" placeholder="排放时间"></QHdatePicker>
        </li>
        <li>
          <Button type="warning" size="small" @click="search">查询</Button>
        </li>
      </ul>
    </template>
    <!--搜索及功能区 end-->

    <!--主体呈现区-->
    <template v-slot:pageContent>
      <QHTable :total="total['pageCount'] || 0" :pageThis="pageThis">
        <Table :columns="columns" :data="list" @on-selection-change="(event) => $tableSeletChange(event, pageThis)" :loading="loading" class="QHTableList">
          <!--分割区-->
          <template slot-scope="{ row }" slot="name">
            <span class="oe1 ">{{ row.name }}</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="garbageNumber"> {{ row.garbageNumber }}m³ </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="emissionTime">
            <span class="oe1">{{ $timeFmt(row.emissionTime, "YYYY-MM-DD") }}</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="projectId">
            <Tag color="cyan" v-if="row.projectId > 0">已使用</Tag>
            <Tag color="red" v-else>未使用</Tag>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="status">
            <Tag color="default" v-if="row.status == -1">未备案</Tag>
            <Tag color="blue" v-if="row.status == 100">{{ $state["filingStatus"][row.status] }}</Tag>
            <Tag color="cyan" v-if="row.status == 200">{{ $state["filingStatus"][row.status] }}</Tag>
            <Tag color="red" v-if="row.status == 300">{{ $state["filingStatus"][row.status] }}</Tag>
          </template>
          <!--分割区-->
          <template slot-scope="{ row }" slot="open_type">
            <Tag color="cyan" v-if="row.open_type == 200">已同步</Tag>
            <Tag color="red" v-else>未同步</Tag>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="action">
            <Button type="warning" size="small" @click="$refs.detailed.hiPop(row)">详情</Button>
          </template>
        </Table>
      </QHTable>
    </template>
    <!--主体呈现区 end-->
      <!--弹窗组件区-->
      <template v-slot:pageBlock>
      <detailed ref="detailed"></detailed>
    </template>
    <!--弹窗组件区 end-->
  </layout>
</template>
<script>
import detailed from "./block/detailed/detailed";
export default {
  components: {
    detailed,
  },

  data() {
    return {
      //列表配置项(loading加载效果,columns列,list数据,selectedRows选中,total统计项)@@@@@@@@@@@
      list: [],
      loading: false,
      pageThis: this,
      selectedRows: [],
      total: {},
      columns: this.$colFilter([
        {
          type: "selection",
          width: 40,
          align: "center",
        },
        {
          title: "ID",
          key: "id",
          width: 50,
          align: "center",
        },
        {
          title: "排放单位",
          key: "name",
          minWidth: 120,
          slot: "name",
        },
        {
          title: "备案编号",
          key: "NO",
          width: 140,
          align: "center",
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "排放垃圾",
          key: "garbageTypeName",
          align: "center",
          width: 80,
        },
        {
          title: "排放数量",
          key: "garbageNumber",
          width: 100,
          align: "center",
          slot: "garbageNumber",
        },
        {
          title: "排放时间",
          key: "emissionTime",
          width: 100,
          align: "center",
          slot: "emissionTime",
        },
        {
          title: "所在城市",
          key: "cityName",
          width: 80,
          align: "center",
        },
        {
          title: "所在区域",
          key: "districtName",
          width: 80,
          align: "center",
        },
        {
          title: "所在街道",
          key: "streetName",
          width: 100,
          align: "center",
        },
        {
          title: "联系姓名",
          key: "contactName",
          width: 80,
          align: "center",
        },
        {
          title: "联系电话",
          key: "contactTel",
          width: 110,
          align: "center",
        },
        {
          title: "申请时间",
          key: "created",
          width: 135,
          align: "center",
          render: (h, parameter) => {
            var row = parameter.row;
            let time = this.$timeFmt(row.created, "YYYY-MM-DD HH:mm");
            return h("span", time);
          },
        },
        {
          title: "备案使用",
          key: "projectId",
          align: "center",
          width: 95,
          slot: "projectId",
        },
        {
          title: "备案状态",
          key: "status",
          width: 80,
          fixed: "right",
          align: "center",
          slot: "status",
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          width: 80,
          slot: "action",
          align: "center",
        },
      ]),

      //搜索配置项(searchMap触发才生效,searchMap改变就生效)@@@@@@@@@@@@@@@@@@@@@@@
      searchMap: {
        pageNo: 1,
        daterange: "",
        keyword: "",
      },
      searchMap: {
        keyword: "",
        status: 100,
        pageNo: 1,
        pageSize: 25,
      },

      //其他逻辑配置项@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
      updateStatusShow: false,
      updateStatusLength: 0,
    };
  },

  // +----------------------------------------------------------------------
  // | mounted
  // +----------------------------------------------------------------------
  mounted() {
    var year = this.$getUrlParams("year");
    this.searchMap.daterange = this.$yeaerStartEnd(year);
    this.$refs.QHleftcity.int();
  },

  methods: {
    // +----------------------------------------------------------------------
    // | 切换数据地址数据
    // +----------------------------------------------------------------------
    change(res) {
      this.searchMap.code = res.code;
      this.searchMap.level = res.level;
      this.dataName = res.name;
      
    },

    cityLoading(res) {
      this.searchMap.code = res.code;
      this.searchMap.level = res.level;
       
      this.getList();
    },

    // +----------------------------------------------------------------------
    // | 列表
    // +----------------------------------------------------------------------
    getList() {
      var that = this;
      var https = {
        type: "isPagelist",
        api: this.$api.getFilingList,
        parameter: this.searchMap,
      };
      this.$httpsApi(https, function () {
        that.dataLoading = true;
      });
    },

    // +----------------------------------------------------------------------
    // | 搜索
    // +----------------------------------------------------------------------
    search() {
      this.getList();
    },
  },
};
</script>
